import React from 'react';
import { SpinnerIcon } from '@THC/components/Icons';
import { filterDataProps } from '@THC/utils/helpers';
import { VisuallyHidden } from '../__primitives__/VisuallyHidden';
import { IconText } from '../IconText';
import { resolveIconTextVariant } from './LoadingIndicator.helpers';
import styles from './LoadingIndicator.module.scss';
export const LoadingSpinner = ({ showText = false, size = 'small', text = 'Loading', ...rest }) => {
    let variantValue;
    if (showText) {
        variantValue = resolveIconTextVariant(size);
    }
    return (<span className={styles.loadingIndicator} role="status" {...filterDataProps(rest)}>
			{variantValue ? (<IconText icon={SpinnerIcon} text={text} variant={variantValue}/>) : (<>
					<SpinnerIcon size={size}/>
					<VisuallyHidden>{text}</VisuallyHidden>
				</>)}
		</span>);
};
